import {getEvents} from '../services/cms.service';
import {markdown} from 'markdown';

export default {
  template: `
      <section class="Events Section">
        <div class="ms-Grid">
          <div class="ms-Grid-row">
            <div class="ms-Grid-col ms-sm12 ms-xl6">
              <h2 class="Section-heading">
                Je komt ons overal tegen
              </h2>
            </div>
          </div>
          <div class="ms-Grid-row">
            <div class="ms-Grid-col ms-sm12">
              <div class="Section-body">
                <div class="Events-carousel">
                  <v-touch v-on:swipeleft="scrollToNextItem" v-on:swiperight="scrollToPrevItem">
                    <div class="Events-carouselViewport">
                      <div
                        class="Events-carouselViewportScroller"
                        v-bind:style="{ transform: 'translateX(-' + visibleItemIndex * 100 + '%)' }"
                      >
                        <div class="Events-item" v-for="item in items">
                          <div class="ms-Grid">
                            <div class="ms-Grid-row adesso-grey-background">
                              <div class="ms-Grid-col ms-sm12 ms-xl7">
                                <div class="Events-itemPhoto" v-if="!item.videoLink">
                                  <img v-bind:src="'https://www.datocms-assets.com' + item.image.path" v-bind:alt="item.image.alt">
                                </div>
                                <a class="Events-itemPhoto Events-itemPhoto--videoLink" v-if="item.videoLink" v-bind:href="item.videoLink" target="_blank" title="Bekijk de video">
                                  <img v-bind:src="'https://www.datocms-assets.com' + item.image.path" v-bind:alt="item.image.alt">
                                </a>
                              </div>
                              <div class="ms-Grid-col ms-sm12 ms-xl4">
                                <div class="Events-itemText">
                                  <h3 class="Events-itemMeta">
                                    {{ item.date }}
                                    <br>{{ item.location }}
                                  </h3>
                                  <h4 class="Events-itemTitle">
                                    {{ item.title }}
                                  </h4>
                                  <p class="Events-itemBody" v-html="item.description"></p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </v-touch>

                  <button
                    class="Events-prevButton"
                    @click="scrollToPrevItem"
                    v-bind:disabled="!canScrollToPrevItem"
                  >
                    <span class="Events-prevButton-text">Vorige</span>
                  </button>

                  <button
                    class="Events-nextButton"
                    @click="scrollToNextItem"
                    v-bind:disabled="!canScrollToNextItem"
                  >
                    <span class="Events-prevButton-text">Volgende</span>
                  </button>
                </div>

                <ol class="Events-pagination">
                  <li v-for="(item, index) in items">
                    <button
                      v-bind:class="{ 'Events-paginationButton': true, 'Events-paginationButton--active': index === visibleItemIndex }"
                      @click="scrollToItem(index)"
                    >
                      <div class="Events-paginationButton-bullet">
                        <div class="Events-paginationButton-text">{{ index + 1 }}</div>
                      </div>
                    </button>
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </div>
      </section>
    `,
  data: () => {
    return {
      items: [],
      visibleItemIndex: 0
    };
  },
  mounted: function () {
    getEvents().then(records => {
      this.items = records.map(record => ({
        ...record,
        description: markdown.toHTML(record.description)
      }));
    });
  },
  computed: {
    canScrollToNextItem: function () {
      return this.visibleItemIndex < this.items.length - 1;
    },

    canScrollToPrevItem: function () {
      return this.visibleItemIndex > 0;
    }
  },
  methods: {
    scrollToNextItem: function () {
      if (this.canScrollToNextItem) {
        this.visibleItemIndex = this.visibleItemIndex + 1;
      }
    },

    scrollToPrevItem: function () {
      if (this.canScrollToPrevItem) {
        this.visibleItemIndex = this.visibleItemIndex - 1;
      }
    },

    scrollToItem: function (index) {
      this.visibleItemIndex = index;
    }
  }
};



// WEBPACK FOOTER //
// ./src/js/components/events-section.component.js